import fetch from '@/utils/fetch';
import moment from 'moment';

const toThousands = (num) => {
  let str;
  switch (num.length % 3) {
    case 1:
      str = `00${num}`;
      break;
    case 2:
      str = `0${num}`;
      break;
    default:
      str += `${num}`;
  }
  return str.match(/\d{3}/g).join(',').replace(/^0+/, '');
};
const formatMoney = (arg) => {
  if (arg - 0 === 0) {
    return arg;
  }
  const part = `${arg}`.split('.');
  if (part.length > 1) {
    if (toThousands(part[0]) === '') {
      return `0.${part[1]}`;
    }
    return `${toThousands(part[0])}.${part[1]}`;
  }
  return `${toThousands(part[0])}`;
};

const newFormatMoney = (value) => {
  return (
    parseFloat(value / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) || '0.00'
  );
};

const INITIAL_DATE_ARR = [
  moment().add(-7, 'days').startOf('day').format('YYYY-MM-DD'),
  moment().add(-6, 'days').startOf('day').format('YYYY-MM-DD'),
  moment().add(-5, 'days').startOf('day').format('YYYY-MM-DD'),
  moment().add(-4, 'days').startOf('day').format('YYYY-MM-DD'),
  moment().add(-3, 'days').startOf('day').format('YYYY-MM-DD'),
  moment().add(-2, 'days').startOf('day').format('YYYY-MM-DD'),
  moment().add(-1, 'days').startOf('day').format('YYYY-MM-DD'),
];

const model = {
  state: {
    date: [moment().add(-6, 'days').startOf('day'), moment().add(0, 'days').startOf('day')], // 默认前一周
    tableLoading: true,
    orderData: {
      order_total: 0,
      order_total_chain: 0,
      trade_total: 0,
      trade_total_chain: 0,
      income_total: 0,
      income_total_chain: 0,
      customer_price: 0,
      customer_price_chain: 0,
      pay_price: 0,
      pay_price_total: 0,
      cancel_order_total: 0,
      refund_order_total: 0,
      effective_order_count: 0,
      order_price: 0,
      order_price_after_discount: 0,
      refund_order_price: 0,
      discount_order_price: 0,
      pay_rate: 0,
    },
    merchantData: {
      merchant_total: 0,
      new_merchant_total: 0,
      sub_shop_total: 0,
      share_people: 0,
    },
    // 子门店列表
    subShops: [],
    // 所属子门店
    belongShop: 0,
    realTimeBelongShop: 0,
    realData: {},
    orderNum: [],
    peopleNum: [],
    dateLine: INITIAL_DATE_ARR,
    topData: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { dataOverview }, getState }) => ({
    startLoading(type) {
      const { loading } = getState().dataOrders;
      const nowLoading = [...loading, type];
      dataOverview.setState({ loading: nowLoading });
    },
    endLoading(type) {
      const { loading } = getState().dataOrders;
      const nowLoading = loading.filter((item) => item !== type);
      dataOverview.setState({ loading: nowLoading });
    },
    setDate(value) {
      dataOverview.setState({ date: value });
    },
    async queryAnalytics(args) {
      const { shop_id, shopType } = getState().basic;
      const { belongShop } = getState().dataOverview;
      const params = {
        ...args,
        shop_id,
        sub_shop_id: belongShop,
        sub_status: shopType === 'main' ? 1 : 0,
      };
      dataOverview.setState({ tableLoading: true });
      const data = await fetch('/trade/deal/analytics', { params });
      dataOverview.setState({ tableLoading: false });
      if (Object.keys(data).length > 0) {
        let i = 0;
        data.deal_data = data.deal_data || [];
        data.order_price_total = formatMoney((data.order_price_total / 100).toFixed(2));
        data.pay_price_total = formatMoney((data.pay_price_total / 100).toFixed(2));
        data.per_person_total = formatMoney((data.per_person_total / 100).toFixed(2));
        data.order_count_total = formatMoney(data.order_count_total);
        data.order_person_total = formatMoney(data.order_person_total);
        data.pay_count_total = formatMoney(data.pay_count_total);
        data.pay_person_total = formatMoney(data.pay_person_total);
        data.visit_uv_total = formatMoney(data.visit_uv_total);

        while (i < data.deal_data.length) {
          data.deal_data[i].order_price = (data.deal_data[i].order_price / 100).toFixed(2);
          data.deal_data[i].pay_price = (data.deal_data[i].pay_price / 100).toFixed(2);
          data.deal_data[i].per_person = (data.deal_data[i].per_person / 100).toFixed(2);
          data.deal_data[i].change_pay_price = (data.deal_data[i].change_pay_price / 100).toFixed(
            2,
          );
          i += 1;
        }
        dataOverview.setState({
          analyticsSource: data && data.deal_data ? data.deal_data : [],
          totalData: data ? { ...data } : {},
        });
      }
    },
    async getOverviewData() {
      const { date } = getState().dataOverview;
      const beginTime = date[0].startOf('day').format('YYYY-MM-DD');
      const endTime = date[1].endOf('day').format('YYYY-MM-DD');
      try {
        dataOverview.setState({
          tableLoading: true,
          topData: [],
        });
        const result = await fetch('/datahub/crm/dataoverview/overview', {
          type: 'POST',
          useJson: true,
          params: {
            // shop_id,
            // sub_shop_id,
            // union_shop_id: isPolymer ? union_shop_id : 0,
            beginTime,
            endTime,
          },
        });
        if (result && Object.keys(result).length > 0) {
          // 订单数据
          const order = result.orderOverview;
          order.orderTotal = order.orderTotal || 0;
          // order.orderTotalChain = (order.orderTotalChain / 100).toFixed(2);
          order.tradeTotal = newFormatMoney(order.tradeTotal);
          // order.tradeTotalChain = (order.tradeTotalChain / 100).toFixed(2);
          // order.incomeTotal =
          // order.incomeTotal && formatMoney((order.incomeTotal / 100).toFixed(2));
          // order.incomeTotalChain = (order.incomeTotalChain / 100).toFixed(2);
          // order.customerPrice =
          //   order.customerPrice && formatMoney((order.customerPrice / 100).toFixed(2));
          // order.customerPriceChain = (order.customerPriceChain / 100).toFixed(2);
          // order.payRate = (order.payRate / 100).toFixed(2);
          // order.payRateChain = (order.payRateChain / 100).toFixed(2);
          order.cancelOrderTotal = order.cancelOrderTotal || 0;
          order.refundOrderTotal = order.refundOrderTotal || 0;
          order.effectiveOrderCount = order.effectiveOrderCount || 0;
          // order.orderPrice =
          // order.orderPrice && formatMoney((order.orderPrice / 100).toFixed(2));
          // order.orderPriceAfterDiscount =
          //   order.orderPriceAfterDiscount &&
          //   formatMoney((order.orderPriceAfterDiscount / 100).toFixed(2));
          order.refundOrderPrice = newFormatMoney(order.refundOrderPrice);
          // order.discountOrderPrice =
          //   order.discountOrderPrice &&
          //   formatMoney((order.discountOrderPrice / 100).toFixed(2));
          order.gmv = newFormatMoney(order.gmv);
          order.effectiveGmv = newFormatMoney(order.effectiveGmv);
          order.platformActivityAmount = newFormatMoney(order.platformActivityAmount);
          order.merchantFavorable = newFormatMoney(order.merchantFavorable);
          order.pricePerCustomer = newFormatMoney(order.pricePerCustomer);
          order.avgOrderPrice = newFormatMoney(order.avgOrderPrice);
          order.groupQuickpayOrderPrice = newFormatMoney(order.groupQuickpayOrderPrice);

          let orderNum = [];
          let peopleNum = [];
          let dateLine = [];
          if (result.chart) {
            if (result.chart.order_total.length) {
              orderNum = result.chart.order_total.map((item) => item.value);
              dateLine = result.chart.order_total.map((item) =>
                moment(item.date * 1000).format('YYYY-MM-DD'),
              );
            }
            if (result.chart.visit_people.length) {
              peopleNum = result.chart.visit_people.map((item) => item.value);
              dateLine = result.chart.order_total.map((item) =>
                moment(item.date * 1000).format('YYYY-MM-DD'),
              );
            }
          }
          dataOverview.setState({
            orderData: order,
            orderNum,
            peopleNum,
            topData: result.top,
            tableLoading: false,
            dateLine,
          });
        }
      } catch (e) {
        dataOverview.setState({
          tableLoading: false,
        });
      }
    },
  }),
};

export default model;
